export default __webpack_public_path__ + "static/media/journal-screen.87628e55.png";